import { FlowioThunkCreator } from "../../types";
import { GlobalFetchPartition } from "../reducer";
import { fetchNavMenuPartition } from "./fetchNavMenuPartition";
import { fetchHomepagePartition } from "./fetchHomepagePartition";

type ThunkCollection = Record<GlobalFetchPartition, FlowioThunkCreator<void>>;
const collection: ThunkCollection = {
  homepage: fetchHomepagePartition,
  navMenu: fetchNavMenuPartition,
};

export default collection;
